import { Container, EventCard } from '@aether/components'
import { EventsPageData } from '@aether/services/sanity-service'
import { styled } from '@aether/styles'
import { useTranslation } from 'react-i18next'

const TitleH1 = styled('h1', {
  $aetherFont: 'heading04',
  marginBottom: '$16',

  '@lg': {
    $aetherFont: 'heading03',
    marginBottom: '$32',
  },
})

const TitleH2 = styled('h2', {
  display: 'none',

  '@lg': {
    display: 'block',
    $aetherFont: 'heading03',
    marginBottom: '$32',
  },
})

const Space = styled('div', {
  marginTop: '$40',

  '@lg': {
    marginTop: '$96',
  },
})

const Grid = styled('section', {
  display: 'grid',
  width: '100%',
  gap: '$40',
  variants: {
    columns: {
      twoToThree: {
        gridTemplateColumns: '1fr',
        '@lg': {
          gridTemplateColumns: 'repeat(2, 1fr)',
        },
        '@media (min-width: 1600px)': {
          gridTemplateColumns: 'repeat(3, 1fr)',
        },
      },
      three: {
        gridTemplateColumns: '1fr',
        '@lg': {
          gridTemplateColumns: 'repeat(3, 1fr)',
        },
      },
    },
  },
  defaultVariants: {
    columns: 'twoToThree',
  },

  '&:last-child': {
    marginBottom: '$96',
  },

  '@lg': {
    marginBottom: '$96',
  },
})

export const Events: React.FC<{
  pageData: EventsPageData
}> = ({ pageData }) => {
  const { t } = useTranslation('events')

  return (
    <Container spaceSize="small" as="main">
      <TitleH1>{t('aetherEvents')}</TitleH1>
      <Grid>
        {pageData?.featuredEvents?.map((event) => (
          <EventCard key={event._id} {...event} />
        ))}
      </Grid>
      <Space />
      <TitleH2>{t('pastEvents')}</TitleH2>
      <Grid columns="three">
        {pageData?.pastEvents?.map((event) => (
          <EventCard
            key={event._id}
            {...event}
            isArchived={event.isEventEnded}
          />
        ))}
      </Grid>
    </Container>
  )
}
